//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RestProp from '~/components/rest-prop'
// import RestPropLink from '~/components/rest-prop-link'
import RestModel from '~/components/rest-model'
import RestImg from '~/components/rest-img'


export default {
	components:
	{
		'rest-prop': RestProp,
		RestModel,
		RestImg,
		// 'rest-link': RestPropLink,
	},

	props:
	{
		item:
		{
			type: Object,
			required: true,
		},

		url:
		{
			type: String,
			default: 'block'
		},

		// img:
		// {
		// 	type: String,
		// 	required: true,
		// },

		// title:
		// {
		// 	type: String,
		// 	required: true,
		// },

		// subtext:
		// {
		// 	type: String,
		// 	required: true
		// }
	}
}
